import React, { Component } from 'react';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown';
import { CommonValidationMessages } from '../../../utils/Messages';

class ProductionDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isTable2Expanded: false,
            rowData: [],
            colDefs: [],
            row2Data: [],
            col2Defs: [],
            requestDetails: {},
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {},
            paginationPageSize: 50,
            rowHeight: 40,
        };
    }

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else {
                return {};
            }
        });
    };

    handleCellClick = (event) => {
        // this.procItemStockRegisterTracking_ByItemGroup(event.data.idItemGroup, event.colDef.field);
    };

    render() {
        return (
            <div className='item-wise-stock-detail-report'>
                <div className="data-display">
                    <div className="data-display-inner">
                        <div className="table w-full cursor-default bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 337px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Production data</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    rowSelection={this.rowSelection}
                                    onCellClicked={this.handleCellClick}
                                />
                            </div>

                        </div>

                        <div className="table w-full cursor-default bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px] mt-5">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Process details</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.row2Data}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.col2Defs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    rowSelection={this.rowSelection}
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default ProductionDashboard;